// extracted by mini-css-extract-plugin
export default {"item":"Item_item__WA7Gi","selectedItem":"Item_selectedItem__nViYr","concludedItem":"Item_concludedItem__WVUc2","concluded":"Item_concluded__AgL4L"};